exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-full[data-v-335a1315]{height:100%}.w-full[data-v-335a1315]{width:100%}.p-10px[data-v-335a1315]{padding:10px}.bg-\\[\\#fff\\][data-v-335a1315]{background:#fff}.\\!w-150px[data-v-335a1315]{width:150px!important}.mr-10px[data-v-335a1315]{margin-right:10px}.mb-10px[data-v-335a1315]{margin-bottom:10px}.mt-10px[data-v-335a1315]{margin-top:10px}", ""]);

// exports
